import React, { useCallback, useEffect, useState } from 'react';
import { openCenterModal } from 'lib/launchGame/utils';
import { getFantawinnerGameUrl, retrieveTopSlots } from 'features/slotArchive/actions';
import { useAppDispatch } from 'lib/centralStore';
import { PayloadAction } from '@reduxjs/toolkit';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';

export const useLaunchFantawinner = () => {
  const dispatch = useAppDispatch();

  const launchFantawinner = useCallback(
    async (height: number, width: number) => {
      try {
        const { url } = await dispatch(getFantawinnerGameUrl()).unwrap();
        if (url) openCenterModal({ url: url, heightSize: height, widthSize: width });
      } catch (error) {
        console.error('Errore durante il lancio', error);
      }
    },
    [dispatch]
  );

  return { launchFantawinner };
};

export const useGetTopSlots = (idList: string[]) => {
  const dispatch = useAppDispatch();
  const [response, setResponse] = useState<PayloadAction<any>>({
    type: QueryStatus.pending,
    payload: {},
  });

  useEffect(() => {
    const getData = async () => {
      const r = await dispatch(retrieveTopSlots(idList));
      setResponse(r ?? {});
    };

    getData();
  }, [dispatch, idList]);

  return response;
};